import { toast } from 'react-toastify';

export function toastError(error) {
    if (error.response && error.response.data) {
        if (error.response.data.userMessage) return toast.error(error.response.data.userMessage);
        return toast.error(error.response.data.message)
    } else {
        return toast.error(error.message);
    }
}